<script>
  import OptionItem from './OptionItem.svelte';

  export let options = [];
  export let highlight = (text) => text;
  export let multiple = false;
  export let value = '';
  export let selected = [];
  export let hidePopup = false;


  let component;


  function selectItem(item){
    if (item.hasOwnProperty('expired') && !item.expired) {
      item.selected = true;
    } else {
      item.selected = false;
      return;
    }

    if(multiple){
      value = [...value, item.id];
      selected = [...selected, item];    
    } else {
      selected = [item];
      value = item.id;
      hidePopup = true;
    }
    
    options = [...options];
  }

  function hideItem(item){
    let hide = false;

    if(multiple && item.select){
      hide = true;
    } else {
      hide = item.hidden;
    }
    return hide;
  }

</script>

<div class="options" bind:this={component}>
  {#each options as option}
    {#if !hideItem(option)}
    <OptionItem 
      item={option} 
      {highlight}
      selected={value}
      on:select={() => selectItem(option)}
    />
    {/if}
  {/each}
</div>

<style>
  .options {max-height: 250px; overflow-y: auto}

  ::-webkit-scrollbar
  {
    width: 6px;  /* for vertical scrollbars */
    height: 6px; /* for horizontal scrollbars */
  }

  ::-webkit-scrollbar-track
  {
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb
  {
    background: rgba(0, 0, 0, 0.3);
  }

</style>
